enum ComponentNameCycleList {
  Controllers = 'Controllers',
  Channels = 'Channels',
  Thermocouples = 'Thermocouples',
};

export default ComponentNameCycleList;
